import React from "react";
const Amount = ({claim}) => {
     const aiData = claim.aiExtractedVariables || {};
     console.log("Amount claim", claim);
    return (
        <>
        <td>
<div className="d-flex align-items-center gap-2">
                <span style={{ fontWeight: 600, color: "#111827" }}> {aiData.TotalAmount || ""}</span>
            </div>
        </td>
            
        </>
    )
}

export default Amount